import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { OrdinalDateAdapter, OrdinalDateParse, ORD_DATE_FORMATS } from '../adapters/ordinal-date-adapter';
import { AddObservationPointModal } from '../add-observation-point/add-observation-point-modal';
import { DigitalFormService } from '../digital-form-fill/digital-form.service';
import { componentListsVM } from '../equipment-details/equipment-details.model';
import { ObservationPointVM, ComponentsVM } from '../favourite-dialog/favourite-dialog-modal';
import { ImplementDetailsService } from '../implement-details/implement-details.service';
import { ComponentVM, CrackStatusVM, DrawShape, Points } from '../setup-implement/setup-implement.model';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GETPreferencesService } from '../preferences/preferences.service';
import moment from 'moment';
import { InspectionCompTypeCompObsPoints, InspectionObservationPointsViewModel, ObservationImagesViewModel } from '../inspections/inspection.model';
import { ConfirmationBoxComponent } from '../../../shared/confirmation-box/confirmation-box.component';
import { ViewChildren } from '@angular/core';
import { QueryList } from '@angular/core';
import { NewInspectionService } from '../inspections/inpsection.service';
import { AppService } from '../../../app.service';
import { DatePipe } from '@angular/common';
import { CrackStatusesVM } from '../entities/component/model';

@Component({
  selector: 'app-add-crack-obs-point-dialog',
  templateUrl: './add-crack-obs-point-dialog.component.html',
  styleUrls: ['./add-crack-obs-point-dialog.component.scss'],
  providers: [
    {
      provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
      provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
  ]
})
export class AddCrackObsPointDialogComponent implements OnInit {
  @ViewChild('image') imageRef!: ElementRef<HTMLImageElement>;

  schematic: string;
  obsDetails: ObservationPointVM[];
  _obsDetailExisting: InspectionCompTypeCompObsPoints;
  componentList: ComponentVM[]
  componentList_: ComponentVM[]
  schematicID: number;
  isDFI: boolean = false;
  IsGETInspection: boolean = false;
  inspectionDate: Date;
  userUOM: string = "mm";
  comments: string;
  implementInspectionId: number = 0;
  images: string[] = ['', '', '', '', ''];
  _ObservationImages: ObservationImagesViewModel[];
  loading: boolean;
  _ObsPointSaved: boolean = false;
  _allowDelete: boolean = true;
  _showCrackTypeOption: boolean = true;
  _showOtherTypeOption: boolean = true;
  obsLocationId: number;
  crackSeverityId: number;
  obsList: any;
  severityList: any;
  isGlobalImg: boolean = false;
  implementId: number;
  IsCrack: boolean = false;
  IsObsCrack: boolean = false;
  showCrackLocation: boolean = false;
  showCrackSeverity: boolean = false;
  crackLocationId: number;
  selectedComponentId: number;
  crackLocationlist: any;
  enableNormal: boolean = true;
  enableEvaluation: boolean = true;
  enableSelection: boolean = true;
  enablePassFail: boolean = true;
  enableYesNo: boolean = true;
  Qname: string
  Qdesc: string
  OPQuestionImage: string
  sToolTip_NoOfReadings: string = "If your observation point does not require a measurement please set No. of Readings to 0.";
  @ViewChildren('fileInput') fileInputs!: QueryList<ElementRef>;
  shapes: DrawShape[] = [];
  showFixedCracks: boolean = true;
  allObsDetails: ObservationPointVM[];
  activeCrackStatusIds: number[] = [];
  crackOptions: CrackStatusVM[] = [];
  selectedFile: File;
  ModelImage_fromPC: string;
  showAddObservation: boolean = false;
  eventX: number
  eventY: number
  EndeventX: number
  EndeventY: number
  mouseclick: boolean = false
  startXY: string;
  endXY: string;
  minDate: Date = new Date();
  maxDate: Date = new Date();
  eventDate: Date = new Date();
  TempObservationPoints: ObservationPointVM[] = [];
  ord: OrdinalDateParse = new OrdinalDateParse();
  isStartEdit: boolean = false;
  isEndEdit: boolean = false;
  checkedAnswe: boolean = false;
  checkedImage: boolean = false;
  IsImage: boolean;
  IsAnswer: boolean;
  isDisabled: boolean = false;
  isFECRCrack: boolean = false;
  isFECRNormal: boolean = false;
  InspectionTypeList: componentListsVM[];
  InspectionTypeID: number;
  isValid: boolean = false;
  noOfReading: number = 1;
  componentId: number;
  TypeID: number = 2;
  disabledCrackOption: boolean = false;
  limitNew: number = 0;
  limitWorn: number = 0;
  measurement: number;
  checkedComment: boolean;
  Compname: string;
  limitRange: number = 0;
  OPId: number = 0;
  crackStatusId: number;

  @Output() itemSaved = new EventEmitter<any>();

  constructor(private _dialogRef: MatDialogRef<AddCrackObsPointDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any, private _sanitizer: DomSanitizer, public toastr: NotificationsService,
    public _moduleService: ImplementDetailsService,
    private _formService: DigitalFormService,
    private _implementService: SetupImplementService,
    private userPrefService: GETPreferencesService,
    private _inspection: NewInspectionService,
    private _appService: AppService,
    public dialog: MatDialog,
    private datePipe: DatePipe) { }

  ngOnInit() {
    console.log("this.data__", this._data)
    if (this._data.implementInspectionId !== undefined)
      this.implementInspectionId = this._data.implementInspectionId;
    console.log("this.implementInspectionId_", this.implementInspectionId)
    this.obsDetails = this._data.obsDetails;
    this.allObsDetails = deepClone(this.obsDetails);
    this.schematic = this._data.schematic;
    this.componentList = this._data.componentList;
    this.schematicID = this._data.schematicId;
    this.isDFI = this._data.isDFI
    this.IsGETInspection = this._data.IsGETInspection;
    this.inspectionDate = this._data.inspectionDate;
    this.activeCrackStatusIds = this._data.activeCrackIds ?? [];
    if (this._data.TypeID !== undefined) {
      this.TypeID = this._data.TypeID;
    }
    if (this._data.disabledCrackOption !== undefined) {
      this.disabledCrackOption = this._data.disabledCrackOption;
    }
    if (this.activeCrackStatusIds.length !== 0) {
      this.showFixedCracks = this.activeCrackStatusIds.filter(x => x === 1).length > 0 ? true : false;
      this.applyCrackFilter();
    }
    this.checkExistingObsPoint(this._data.obsDetailExisting);
    this.minDate.setDate(this.maxDate.getDate() - 1);
    this.getInspectionTypeList();
    this.getUserPref();
    this.checkForNewCrack();
    this.implementId = this._data.implementId;
    this.isGlobalImg = this._data.isGlobalImg;
    this.selectedComponentId = this._data?.obsDetailExisting?.ComponentId;
    if (this.selectedComponentId)
      this.loadCrackLocations(this.selectedComponentId);
    if (this.isGlobalImg) {
      this.loadObservationLists(true, true, this.implementId, 'obs');
      this.loadObservationLists(true, false, this.implementId, 'severity');
    }
    else {
      //this.obsLocationId = this._data?.obsDetailExisting?.severityIDs?.[0] ?? null;
      this.obsLocationId = this._data?.obsDetailExisting?.obsId ?? null;
      this.crackSeverityId = this._data?.obsDetailExisting?.severityID;
      this.obsList = this._data?.obsDetailExisting?.ObsList;
      this.severityList = this._data?.obsDetailExisting?.obsSeverityList;
      this.showCrackSeverity = !!this.severityList?.length;
      this.showCrackLocation = !!this.obsList?.length;
      this.crackLocationId = this._data?.obsDetailExisting?.CrackLocationId;
    }
    console.log(this.obsLocationId, this.crackSeverityId, this.obsList, this.severityList);
    this.loadSavedShapes();
    this.getCrackStatuses();
  }

  checkForNewCrack() {
    if (this.TypeID == 2) {
      if (this.OPId <= 0)
        this.limitWorn = 1;
      this.isStartEdit = true;
    }
  }

  applyCrackFilter() {
    if (!this.allObsDetails?.length) {
      this.obsDetails = [];
      return;
    }
    this.obsDetails =
      this.allObsDetails.filter(op => {
        if (op.observationPointTypeId !== 2) {
          return true;
        }
        return this.activeCrackStatusIds.includes(op.CrackStatusId);
      });
  }

  isImageAsUrl(image: string){
    return /^https?:\/\//i.test(image);
  }

  getImage(image: string) {
    //const isUrl = /^https?:\/\//i.test(image);
    return this._sanitizer.bypassSecurityTrustResourceUrl(
      this.isImageAsUrl(image) ? image : `data:image/png;base64,${image}`
    );
  }

  onToggleFixedCracks() {
    if (this.showFixedCracks) {
      this.obsDetails = [...this.allObsDetails];
    } else {
      this.obsDetails = this.allObsDetails.filter(
        x => !(x.observationPointTypeId === 2 && x.CrackStatusId === 1)
      );
    }
  }


  // getPosition(posX: string, posY: string) {
  //   var iPX = (parseFloat(posX));
  //   var iPY = (parseFloat(posY));
  //   return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;z-inde:1');
  // }

  loadObservationLists(isCrack: boolean, isObsCrack: boolean, implementId: number, target: 'obs' | 'severity') {
    this._implementService.GetCrackObsList(isCrack, isObsCrack, implementId).subscribe(res => {
      if (target === 'obs') {
        this.obsList = res;
        this.showCrackLocation = !!this.obsList?.length;
      } else {
        this.severityList = res;
        this.showCrackSeverity = !!this.severityList?.length;
      }
    });
  }

  loadCrackLocations(componentId: number) {
    this._inspection.GetCrackObsLocations(componentId).subscribe(res => {
      this.crackLocationlist = res;
      console.log("crackLocationlist", this.crackLocationlist);
    });
  }

  loadSavedShapes(): void {
    if (this.schematicID !== undefined) {
      this._implementService.getSchematicComponentsRecognitionsDetails(this.schematicID, this.implementId).subscribe({
        next: (res: DrawShape[]) => {
          this.shapes = res.map((s, index) => ({
            id: index + 1,
            componentId: s.componentId,
            points: s.points ?? [],
            locations: s.locations ?? [],
            newLocation: '',
            componentGroupNumber: 1
          }));

          //this.redraw();
        },
        error: err => {
          console.error('Failed to load shapes', err);
        }
      });
    }
  }

  /////////////////////////////
  // OBSERVASION POINTS METHODS //
  /////////////////////////////

  getPosition(posX: string, posY: string) {
    var iPX = (parseFloat(posX));
    var iPY = (parseFloat(posY));
    return {
      position: 'absolute',   // Add this if necessary for positioning
      left: `${iPX}px`,
      top: `${iPY}px`
    };
    //return this._sanitizer.bypassSecurityTrustStyle('Left: ' + iPX.toString() + 'px;' + 'Top: ' + iPY.toString() + 'px;' + 'Position: absolute;');
  }

  getLine(posX: string, posY: string, EndposX: string, EndposY: string, isCrackFixed: boolean, cp: ObservationPointVM) {
    // bottom right
    var x1 = (parseFloat(posX))
    var y1 = (parseFloat(posY));
    // top right
    var x2 = (parseFloat(EndposX))
    var y2 = (parseFloat(EndposY));
    // distance
    var length = Math.sqrt(((x2 - x1) * (x2 - x1)) + ((y2 - y1) * (y2 - y1)));
    // center
    var cx = (((x1 + x2) / 2) - (length / 2)) + 7;
    var cy = ((y1 + y2) / 2) - (4 / 2);
    // angle
    var angle = Math.atan2((y1 - y2), (x1 - x2)) * (180 / Math.PI);
    // make hr
    var colour = cp.ColorCode != null ? cp.ColorCode : (isCrackFixed == false ? "#EC0A0A" : "#63c94b");
    return this._sanitizer.bypassSecurityTrustStyle('padding:0px; margin:0px; height:' + 4 +
      'px; background-color:' + colour + '; line-height:1px; position:absolute; left:' + cx +
      'px; top:' + cy + 'px; width:' + length + 'px; -moz-transform:rotate(' + angle + 'deg); -webkit-transform:rotate(' + angle + 'deg); -o-transform:rotate(' + angle + 'deg); -ms-transform:rotate(' + angle + 'deg); transform:rotate(' + angle + 'deg);');

  }

  getEval(wornPct: number, inspectDate: string) {
    if ((wornPct == 0) && (inspectDate == "Never")) {
      return 'gray';
    } else if (wornPct <= 30) {
      return 'green';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return 'yellow';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return 'orange';
    } else if (wornPct > 80) {
      return 'red';
    }
    else {
      return 'magenta';
    }
  }

  checkPositive() {
    if (this.limitNew < 0) {
      this.limitNew = 0;
    }
    if (this.limitWorn < 0) {
      this.limitWorn = 0;
    }
  }

  ChangeIsAnswer(valeu) {

    this.checkedAnswe = valeu
  }
  ChangeIsImage(valeu) {

    this.checkedImage = valeu

  }

  checkMaxReading() {
    if (this.noOfReading > 5) {
      this.noOfReading = 5
    }
    if (this.noOfReading <= 0) {
      this.noOfReading = 0
    }
  }

  dateChanged() {
    console.log("beforee", this.eventDate)
    this.ord.formatDateOrdinal((this.eventDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);
    console.log("dateeeee", this.eventDate)
  }
  ValidateNumberInputs(e) {
    if (e.keyCode != 8 && e.keyCode != 0 && (e.keyCode < 48 || e.keyCode > 57)) {
      return false;
    }
  }

  copyValueTolimitWorn(val: string) {
    if (this.TypeID == 2)
      this.limitWorn = Number(val);
  }

  ClearAllXY() {
    if (this.obsDetails.length > 0) {
      this.obsDetails = this.obsDetails.filter(x => x.ObservationPointId !== -1)
    }
    this.startXY = null;
    this.endXY = null;
    if (this.TypeID == 2) {
      this.isStartEdit = true;
      this.isEndEdit = false;
    }
  }
  ClearCurrentStartXY() {
    //this.startXY = null;
    this.isStartEdit = true;
    this.isEndEdit = false;
  }

  ClearCurrentEndXY() {
    //this.endXY = null;
    this.isStartEdit = false;
    this.isEndEdit = true;
  }

  ConfirmStartXY() {
    this.startXY = this.eventX.toString() + " ," + this.eventY.toString();
    console.log("data", this.eventX + " ," + this.eventY)
    if (this.endXY == null) {
      this.isStartEdit = false;
      this.isEndEdit = true;
    }

  }
  ConfirmEndXY() {
    this.endXY = this.EndeventX.toString() + " ," + this.EndeventY.toString();
    console.log("data wnd ", this.EndeventX + " ," + this.EndeventY)
    //this.isEndEdit = false;
  }
  openObservationPointModal(event) {
    //console.log("open obsercation point modal", event)
    //this.RemoveTempOP()
    if (this.TypeID != 2) {
      this.showAddObservation = true;
      this.AddTempOP(event);
      this.eventX = event.offsetX - 10;
      this.eventY = event.offsetY - 10;
      this.mouseclick = true
    } else {

      this.showAddObservation = true;
      this.AddTempOP_Crack(event);
      //this.eventX = event.offsetX - 10;
      // this.eventY = event.offsetY - 10;
      this.mouseclick = true
    }
    const clickPoint: Points = {
      x: this.eventX,
      y: this.eventY
    };
    const componentId = this.getComponentIdByPoint(clickPoint, this.shapes);
    if (componentId != null)
      this.componentId = componentId;
    if (!this.Compname || this.Compname.trim() === '') 
      this.setObsPointName(this.componentId);
    else 
      this.selectedComponentId = componentId;
  }

  checkPoint(op: ObservationPointVM) {
    if (op.observationPointTypeId != 2)
      return true;
    else if (op.observationPointTypeId == 2 && op.ObservationPointId == -1)
      return true;
    else return false;
  }
  //get dreged positions

  // dragEnded(event: CdkDragEnd) {


  //   console.log("x",event.dropPoint.x);
  //   console.log("y",event.dropPoint.y);
  // }

  //end code
  AddTempOP_Crack(event) {
    if (this.isStartEdit || this.isEndEdit) {
      this.TempObservationPoints = this.obsDetails;
      let arr_ = [];

      if (this.TempObservationPoints != null) {
        if (this.TempObservationPoints.find(x => x.ObservationPointId == -1)) {
          let val = this.TempObservationPoints.find(x => x.ObservationPointId == -1);
          if (this.isStartEdit) {
            this.eventX = event.offsetX - 5;
            this.eventY = event.offsetY;
            val.ObservationPointPosX = event.offsetX - 5;
            val.ObservationPointPosY = event.offsetY;
            this.ConfirmStartXY();
          } else if (this.isEndEdit) {
            val.EndObservationPointPosX = event.offsetX - 5;
            val.EndObservationPointPosY = event.offsetY;
            this.EndeventX = event.offsetX - 5;
            this.EndeventY = event.offsetY;
            this.ConfirmEndXY();
          }
          //else {
          //  this.eventX = event.offsetX - 2;
          //  this.eventY = event.offsetY - 2;
          //  val.ObservationPointPosX = event.offsetX - 2;
          //  val.ObservationPointPosY = event.offsetY - 2;
          //}
        }
        else {
          var tempOP: ObservationPointVM = new ObservationPointVM();
          if (this.isStartEdit) {
            tempOP.ObservationPointPosX = event.offsetX - 5;
            tempOP.ObservationPointPosY = event.offsetY;
            this.eventX = event.offsetX - 5;
            this.eventY = event.offsetY;
            this.ConfirmStartXY();
          } else if (this.isEndEdit) {
            tempOP.EndObservationPointPosX = event.offsetX - 5;
            tempOP.EndObservationPointPosY = event.offsetY;
            this.EndeventX = event.offsetX - 5;
            this.EndeventY = event.offsetY;
            this.ConfirmEndXY();
          }
          //else {
          //  this.eventX = event.offsetX - 10;
          //  this.eventY = event.offsetY - 10;
          //  tempOP.ObservationPointPosX = event.offsetX - 10;
          //  tempOP.ObservationPointPosY = event.offsetY - 10;
          //}


          tempOP.isCrackFixed = false;
          tempOP.ObservationPointId = -1;
          tempOP.observationPointTypeId = this.TypeID;
          tempOP.IsNew = true;
          arr_.push(tempOP);

          if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
            this.TempObservationPoints.push(tempOP)
          } else {
            this.TempObservationPoints = arr_;
          }
          this.obsDetails = this.TempObservationPoints;
        }
      }
    }
  }

  AddTempOP(event) {
    this.TempObservationPoints = this.obsDetails;
    let arr_ = [];
    this.RemoveTempOP();
    var tempOP: ObservationPointVM = new ObservationPointVM();
    tempOP.ObservationPointPosX = event.offsetX - 10;
    tempOP.ObservationPointPosY = event.offsetY - 10;
    tempOP.ObservationPointId = -1;
    tempOP.observationPointTypeId = this.TypeID;
    tempOP.IsNew = true;
    arr_.push(tempOP);

    if (this.TempObservationPoints != null && this.TempObservationPoints.length > 0) {
      this.TempObservationPoints.push(tempOP)
    } else {
      this.TempObservationPoints = arr_;
    }
    this.obsDetails = this.TempObservationPoints;
  }

  RemoveTempOP() {
    if (this.TempObservationPoints != null) {
      if (this.TempObservationPoints.find(x => x.ObservationPointId == -1)) {
        this.TempObservationPoints.splice(this.TempObservationPoints.findIndex(x => x.IsNew == true), 1);
      }
    }
    this.TempObservationPoints = this.obsDetails;

  }


  onCloseClick(): void {
    if (this.TempObservationPoints != null) {
      if (this.TempObservationPoints.find(x => x.ObservationPointId == -1)) {
        this.TempObservationPoints.splice(this.TempObservationPoints.findIndex(x => x.IsNew == true), 1);
      }
    }
    this.obsDetails = this.TempObservationPoints;
    this._dialogRef.close(false);
  }

  changeType(event: any) {
    this.TypeID = event.value;
    console.log("type", this.TypeID, event.target, event)
    if (event.value == 3 || event.value == 4) {
      this.isDisabled = true;
      this.isFECRCrack = false;
      this.isFECRNormal = false;
    }
    else if (event.value == 1 && this.limitNew == 0)
      this.limitWorn = 0;
    else if (event.value == 2 && this.limitNew == 0)
      this.limitWorn = 1;
    else {
      this.isDisabled = false;
      this.isFECRCrack = false;
      this.isFECRNormal = false;
    }
    this.ClearAllXY();
    this.limitWorn = this.limitWorn == 1 ? 0 : this.limitWorn;
  }

  saveObservation() {
    this.isValid = true
    if (this.TypeID == null || this.TypeID == 0) {
      this.toastr.error("Please select type.")
      this.isValid = false
    }
    if (this.componentId <= 0 || this.componentId == undefined) {
      this.toastr.error("You must select a component to add an Observation.")
      this.isValid = false
    }
    if (this.Compname == null) {
      this.toastr.error("Please enter Observation Name.");
      this.isValid = false
    }
    if (this.TypeID == 2) {
      if (this.eventX == null || this.eventY == null) {
        this.toastr.error("Please selet a start position from Image.")
        this.isValid = false
      }
      if (this.EndeventX == null || this.EndeventY == null) {
        this.toastr.error("Please selet a end position from Image.")
        this.isValid = false
      }
    }
    else {
      if (this.eventX == null || this.eventY == null) {
        this.toastr.error("Please selet a position from Image")
        this.isValid = false
      }
    }
    if (this.isValid == true) {
      this.saveObservationPoint(false,true);
      this._ObsPointSaved = true;
    }
  }

  saveObservationDetails(saveType: number) {
    this.isValid = true
    let checknoispositive = this.noOfReading % 1;
    console.log("date", this.eventDate)

    //check NO of Reading is Positive and less than 5
    if ((this.noOfReading % 1) != 0) {
      this.toastr.error("Please enter a whole number for Number of Readings")
      this.isValid = false
    }
    if (this.noOfReading > 5) {
      this.toastr.error("Number of Readings must be less than 5")
      this.isValid = false
    }
    if (this.TypeID == null || this.TypeID == 0) {
      this.toastr.error("Please select type ")
      this.isValid = false
    }

    //check has apoisition
    if (this.TypeID == 1) {
      if (this.eventX == null || this.eventY == null) {
        this.toastr.error("Please selet a position from Image")
        this.isValid = false
      }
    }

    //check Measurement Type Validation
    if (this.TypeID == 1 && this.isFECRNormal == false) {
      if (this.noOfReading == 0 || this.noOfReading == null) {
        if (this.limitNew != null || this.limitWorn != null) {
          this.toastr.error("Can not enter values for the Limits")
          this.isValid = false
        }
      }
      else {
        if (this.limitNew == null || this.limitWorn == null) {
          this.toastr.error("Please enter Limits")
          this.isValid = false
        }
        else if (this.limitNew <= this.limitWorn) {
          this.toastr.error("Limit-NEW must greater than the Limit-WORN.")
          this.isValid = false
        }
      }
    }
    else if (this.TypeID == 1 && this.isFECRNormal == true) {
      this.noOfReading = 1;
      this.limitWorn = null;
    }

    else if (this.TypeID == 2 && this.isFECRCrack == true) {
      if (this.noOfReading == 0 || this.noOfReading == null) {
        if (this.measurement != null) {
          this.toastr.error("Can not enter value for the measurement")
          this.isValid = false
        }
      }
      else {
        if (this.measurement == null) {
          this.toastr.error("Please enter Measurement")
          this.isValid = false
        }
      }
    }
    else if (this.TypeID == 2 && this.isFECRCrack == false) {
      if (this.noOfReading == 0 || this.noOfReading == null) {
        if (this.limitNew != null || this.limitWorn != null) {
          this.toastr.error("Can not enter values for the Limits")
          this.isValid = false
        }
      }
      else {
        if (this.limitNew == null || this.limitWorn == null) {
          this.toastr.error("Please enter Crack Length")
          this.isValid = false
        }
        else if (this.limitNew > this.limitWorn) {
          this.toastr.error("Crack Length must not exceed the Maximum Crack Length.")
          this.isValid = false
        }
      }

    }

    //check component is selected
    if (this.componentId <= 0 || this.componentId == undefined) {

      this.toastr.error("You must select a component to add an Observation")
      this.isValid = false
    }



    if (this.Compname == null) {
      this.toastr.error("Please enter Observation Name");
      this.isValid = false
    }

    if (this.isValid == true) {

      if(saveType == 1){
        this.saveObservationPoint(false);
      }else{
      this.saveObservationPoint(true);

      }
    }

  }


  saveObservationPoint(saveAndClose: boolean, isFromSavePoint:boolean = false) {
    this.loading = true;
    if (this.isFECRCrack == true) {
      this.TypeID = 6
    } else if (this.isFECRNormal) {
      this.TypeID = 5
    }
    
    var saveParams: AddObservationPointModal = new AddObservationPointModal();
    saveParams.ImplementInspectionId = this.implementInspectionId;
    saveParams.Name = this.Compname;
    saveParams.ComponentID = this.componentId;
    saveParams.OPId = this.OPId;
    saveParams.ObservationList = []
    saveParams.OPTypeId = this.TypeID
    saveParams.NoOfReadings = this.noOfReading
    saveParams.LimitsNew = this.limitNew
    saveParams.LimitsScrap = this.limitWorn
    saveParams.Comment = 1
    saveParams.Image = 1
    saveParams.positionX = this.eventX
    saveParams.positionY = this.eventY
    saveParams.schematicId = this.schematicID
    saveParams.Qname = this.Qname
    saveParams.Qdesc = this.Qdesc
    saveParams.QuestionImage = this.isImageAsUrl(this.OPQuestionImage) ? null : this.OPQuestionImage;
    saveParams.LimitRange = this.limitRange
    saveParams.Measurement = this.TypeID == 2 ? this.limitNew : this.measurement
    saveParams.isCrackFixed = false;
    saveParams.EndpositionX = (this.TypeID == 2) ? this.EndeventX : null;
    saveParams.EndpositionY = (this.TypeID == 2) ? this.EndeventY : null;
    //saveParams.CreateDate = this.IsGETInspection == false ? this.eventDate : this.inspectionDate;
    saveParams.CreateDate = !this.inspectionDate ? this.eventDate : this.inspectionDate;
    //console.log("CreateDate", saveParams.CreateDate);
    //console.log("StringInspectionDate", new Date(saveParams.CreateDate).toISOString());
    //console.log(this.IsGETInspection == false ? this.eventDate.toISOString() : this.inspectionDate.toISOString());
    saveParams.StringInspectionDate = this.datePipe.transform(saveParams.CreateDate, 'MM/dd/yyyy');
    console.log("StringInspectionDate", saveParams.StringInspectionDate);
    saveParams.InspectionTypeID = this.InspectionTypeID
    saveParams.IsAnswer = this.IsAnswer;
    saveParams.IsImage = this.IsImage;
    saveParams.Comments = this.comments;
    saveParams.Images = this._ObservationImages.filter(i => i.ImageData && i.ImageData.trim() !== "");
    saveParams.CrackSeverityId = this.crackSeverityId;
    saveParams.ObsLocationId = this.obsLocationId;
    saveParams.CrackLocationId = this.crackLocationId;
    saveParams.CrackStatusId = this.crackStatusId;
    //console.log("saveParams,", saveParams);
    if (this.isDFI == true) {
      this._moduleService.storeObservationPointDFI(saveParams).subscribe((res: any) => {
        if (res > 0) {
          this.OPId = res
          this.loading = false;
          this.toastr.success("Observation saved successfully!");
           this.loadCrackLocations(this.selectedComponentId);
          if (saveAndClose) {
            this._dialogRef.close(this.OPId);
            window.location.reload();
          }
        }
        else {
          this.toastr.error("Observation name already exists.");
          this.loading = false;
        }
      })
    } else {
      this._moduleService.SaveObservationPoint(saveParams).subscribe((res: any) => {
        if (res > 0) {
          this.OPId = res
          this.loading = false;
          this.toastr.success("Observation saved successfully!");
        
          if (saveAndClose) {
            this._dialogRef.close(this.OPId);
            window.location.reload();
             this.ClearAllXY();
          }else{
            if(!isFromSavePoint){
            this.OPId=0;
             this.Compname = null;
             this.measurement = null;
            this.componentId = 0;
            this.limitNew = 0;
            this.limitWorn = 0;
            this.noOfReading = 1;
            this.crackSeverityId = null;
            this.obsLocationId = null;
            this.crackLocationId = null;
              this.comments = '';
              this.crackStatusId = null;
            }
            this.startXY = null;
            this.endXY = null;
            //this.setObsPointName(this.componentId);
           const obsDetails= new ObservationPointVM();
           obsDetails.ObservationPointId = this.OPId;
           obsDetails.EndObservationPointPosX = (this.TypeID == 2) ? this.EndeventX : null;
           obsDetails.EndObservationPointPosY = (this.TypeID == 2) ? this.EndeventY : null;
           obsDetails.ObservationPointPosX = this.eventX;
            obsDetails.ObservationPointPosY = this.eventY;
           obsDetails.isCrackFixed = false;
           obsDetails.selected=false;
           obsDetails.ColorCode = "#e4351d";
            obsDetails.observationPointTypeId = this.TypeID;

            this.obsDetails.push(obsDetails);
            this.ClearAllXY();
           
            
            //this.IsAnswer = false;
            //this.IsImage = false;
           //  this._ObservationImages = Array.from({ length: 5 }, () => new ObservationImagesViewModel(-1,'',''));
            
          }
        }
        else {
          this.toastr.error("Observation name already exists.");
          this.loading = false;
        }
      })
    }
  }


  getInspectionTypeList() {
    this._implementService.getInspectionTypeList().subscribe(res => {
      this.InspectionTypeList = res

    })
  }

  onchangeComponent(event) {
    console.log(event.value)
      this.setObsPointName(event.value);
  }

  setObsPointName(componentId: number) {
    if (componentId && componentId > 0) {
      this.componentList_ = this.componentList.filter(f => f.Id == componentId)
      var compName = this.componentList_[0].Name;
      if (compName) {
        const initials = compName.split(' ').map(word => word[0]).join('').toUpperCase();
        const datePart = moment().format('MMDDYY');
        var totalObsPoints = 0;
        if (this.TypeID == 2)
          totalObsPoints = this.obsDetails.filter(f => f.observationPointTypeId == 2)?.length;
        else
          totalObsPoints = this.obsDetails?.length;
        const lengthPart = `${totalObsPoints ? totalObsPoints + 1 : 1}`;
        //this.Compname = initials + datePart + "A" + lengthPart;
        this.Compname = initials + datePart + String(lengthPart).padStart(3, '0');
        this.selectedComponentId = componentId;
        this.loadCrackLocations(this.selectedComponentId);
      }
    }
  }

  getUserPref() {
    this.userPrefService.getUserPreferences().subscribe(res => {
      //console.log('res', res);
      this.userUOM = res.UnitOfMeasurementName;
    });
  }

  replacePhotoClicked(event: any, photoId: number) {
    //this.selectPhotoId = photoId == 1 ? this.photoId : 0;
    if (event.target.files && event.target.files[0]) {
      // var maxsize = 2048000;
      // if (event.target.files[0].size > maxsize) {
      //   alert("This image is too large. Image file size must be 2MB or less.")
      // } else {
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          const imageUrl = (event.target["result"]);
          //resize photo
          this.compressImage(imageUrl).then((res: string) => {
            // console.log("this.images", this._ObservationImages);
            if (res) {
              //this.images.push(res.split(',')[1]);
              this._ObservationImages[photoId].ImageData = res.split(',')[1];
              //console.log("this.images", this.images);
            }
          })
        };
      //}

    }
  }


  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        let width, height;
        width = img.width;
        height = img.height;
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        if (width < imageWidth)
          imageWidth = width;
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  sanitize(image: ObservationImagesViewModel) {
    //console.log("image;", image);
    if (image.ImageData != '') {
      //console.log("image;", image);
      // if (image.ImageDataPath.startsWith('https://') || image.ImageDataPath.startsWith('http://')) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image.ImageData);
    }
    else
      return image.ImageDataPath;
  }

  checkExistingObsPoint(op?: InspectionCompTypeCompObsPoints) {
    console.log("this._data.obsDetailExisting", op);
    this._ObservationImages = Array.from({ length: 5 }, () => new ObservationImagesViewModel(-1, '', ''));
    if (op !== undefined && op !== null) {
      this._obsDetailExisting = op;
      if (this._obsDetailExisting.ObservationPointId !== undefined && this._obsDetailExisting.ObservationPointId > 0) {
        this.OPId = this._obsDetailExisting.ObservationPointId;
        this.componentId = this._obsDetailExisting.ComponentId;
        this.Compname = this._obsDetailExisting.ObservationName;
        this.TypeID = this._obsDetailExisting.ObservationTypeId;
        this.limitNew = this._obsDetailExisting.LimitNew;
        this.limitWorn = this._obsDetailExisting.LimitScrap;
        this.eventX = this._obsDetailExisting.PositionX;
        this.eventY = this._obsDetailExisting.PositionY;
        this.limitRange = this._obsDetailExisting.LimitRange;
        this.measurement = this._obsDetailExisting.Reading;
        this.Qname = this._obsDetailExisting.QuestionTitle;
        this.Qdesc = this._obsDetailExisting.QuestionInstruction;
        this.IsImage = this._obsDetailExisting.isImage;
        this.IsAnswer = this._obsDetailExisting.isAnswer;
        this.OPQuestionImage = this._obsDetailExisting.ImagePath;
        this.crackStatusId = this._obsDetailExisting.CrackStatusId;

        this.obsLocationId = this._obsDetailExisting.obsId ?? null;
        this.crackSeverityId = this._obsDetailExisting.severityID;
        this.obsList = this._obsDetailExisting.ObsList;
        this.severityList = this._obsDetailExisting.obsSeverityList;
        this.showCrackSeverity = !!this.severityList?.length;
        this.showCrackLocation = !!this.obsList?.length;
        this.crackLocationId = this._obsDetailExisting.CrackLocationId;

        this.enableNormal = false;
        this.enableEvaluation = false;
        this.enableSelection = false;
        this.enablePassFail = false;
        this.enableYesNo = false;

        if (this.TypeID == 2) {
          this._showCrackTypeOption = true;
          this._showOtherTypeOption = false;
          this.EndeventX = this._obsDetailExisting.EndPositionX;
          this.EndeventY = this._obsDetailExisting.EndPositionY;
          this.startXY = `${this.eventX ?? ''}, ${this.eventY ?? ''}`;
          this.endXY = `${this.EndeventX ?? ''}, ${this.EndeventY ?? ''}`;
        }
        else if (this.TypeID == 1) {
          this.enableNormal = true;
          this._showCrackTypeOption = false;
          this._showOtherTypeOption = true;
        }

        else {
          this._showCrackTypeOption = false;
          this._showOtherTypeOption = true;
          this.enableNormal = false;
          if (this.TypeID == 3)
            this.enableEvaluation = true;
          if (this.TypeID == 4)
            this.checkHasEnableSelection();
          if (this.TypeID == 5)
            this.checkHasEnablePassFail();
          if (this.TypeID == 6)
            this.checkHasEnableYesNo();
        }
        const recordToUpdate = this.obsDetails.find(item => item.ObservationPointId === this.OPId);
        if (recordToUpdate) {
          recordToUpdate.ObservationPointId = -1;
          recordToUpdate.IsNew = true;
        }
        console.log("recordToUpdate;", recordToUpdate);
        this.showAddObservation = true;
        this.mouseclick = true
        this.comments = this._obsDetailExisting.Comments;

        if (this._obsDetailExisting.ObservationImages && this._obsDetailExisting.ObservationImages.length > 0) {
          this._obsDetailExisting.ObservationImages.forEach((img, index) => {
            if (index < 5) {
              this._ObservationImages[index] = new ObservationImagesViewModel(
                img.Id,
                '', //img.ImageData,
                img.ImageDataPath
              );
            }
          });
        }
        this._ObsPointSaved = true;
      }
    }
    //console.log("this._ObservationImages,", this._ObservationImages);
  }

  get fileInputRefs(): HTMLInputElement[] {
    return this.fileInputs ? this.fileInputs.toArray().map(ref => ref.nativeElement) : [];
  }

  getComponentIdByPoint(point: Points, shapes: DrawShape[]): number | null {
    for (const shape of shapes) {
      if (this.isPointInsidePolygon(point, shape.points)) {
        return shape.componentId;
      }
    }
    return null;
  }

  isPointInsidePolygon(point: Points, polygon: Points[]): boolean {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].x, yi = polygon[i].y;
      const xj = polygon[j].x, yj = polygon[j].y;
      const intersect =
        yi > point.y !== yj > point.y &&
        point.x < ((xj - xi) * (point.y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }

    return inside;
  }

  openDeleteConfirmationBox() {
    this.loading = true;
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        message: 'Are you sure you want to delete this observation point?',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this._implementService.deleteObservationPointFromInspection(this.implementInspectionId, this.OPId).subscribe((r: any) => {
          let json_ = JSON.parse(r)
          if (r && r.includes("Cannot")) {
            console.log('r', r)
            this.toastr.error(r);
            this.loading = false;
            //window.location.reload();
          } else if (r) {
            this.toastr.success(r);
            this.loading = false;
            window.location.reload();
          } else {
            this.toastr.error("There is an error while deleting Obs point.");
            this.loading = false;
          }
        })
      }
      else
        this.loading = false;
    });
  }

  checkHasEnableSelection() {
    this._appService.getApplicationConfigValue("EnableSelectionObservationType").subscribe(result => {
      if (result == "1") {
        this.enableSelection = true;
      } else {
        this.enableSelection = false;
      }
    })
  }
  checkHasEnablePassFail() {
    this._appService.getApplicationConfigValue("EnablePassFailObservationType").subscribe(result => {
      if (result == "1") {
        this.enablePassFail = true;
      } else {
        this.enablePassFail = false;
      }
    })
  }
  checkHasEnableYesNo() {
    this._appService.getApplicationConfigValue("EnableYesNoObservationType").subscribe(result => {
      if (result == "1") {
        this.enableYesNo = true;
      } else {
        this.enableYesNo = false;
      }
    })
  }

  onSelectOPQuestionImage(event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.selectedFile = event.target.files[0];
      reader.onloadend = (e) => {
        this.uploadPhoto(reader.result as string);

      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  uploadPhoto(newPhoto: string) {
    this.ModelImage_fromPC = newPhoto.split(",")[1];
    this.OPQuestionImage = this.ModelImage_fromPC;
  }

  // getCrackStatuses() {
  //   this._implementService.getCrackStatuses().subscribe({
  //     next: (res: CrackStatusVM[]) => {
  //       this.crackOptions = res.map(x => ({ ...x, isSelected: true }));
  //       if(this.activeCrackStatusIds?.length > 0){
  //         this.crackOptions.forEach(co => {
  //           if(!this.activeCrackStatusIds.includes(co.Id)){ 
  //             co.isSelected = false;
  //           }
  //         });
  //       }
  //       console.log('crackOptions', this.crackOptions);
  //     },
  //     error: (err) => {
  //       console.error('Error loading crack statuses', err);
  //     }
  //   });
  // }
  getCrackStatuses() {
    this._implementService.getCrackStatuses().subscribe({
      next: (res: CrackStatusVM[]) => {
        this.crackOptions = res.map(x => ({ ...x, isSelected: true }));
        if (this.activeCrackStatusIds?.length > 0) {
          this.crackOptions.forEach(co => {
            co.isSelected = this.activeCrackStatusIds.includes(co.Id);
          });
          this.applyCrackFilter();
        }
      },
      error: err => console.error(err)
    });
  }

  onCrackChange() {
    this.activeCrackStatusIds = this.crackOptions.filter(o => o.isSelected).map(o => o.Id);
    this.applyCrackFilter();
  }
  // onCrackChange(option: any) {
  //   if (option.isSelected) {
  //     this.obsDetails = [
  //       ...this.allObsDetails.filter(x => {
  //         if (x.observationPointTypeId !== 2) {
  //           return true;
  //         }
  //         return this.crackOptions.some(
  //           o => o.Id === x.CrackStatusId && o.isSelected
  //         );
  //       })
  //     ];
  //   } else {
  //     this.obsDetails =
  //       this.allObsDetails.filter(
  //         x => x.CrackStatusId !== option.Id
  //       );
  //   }
  // }

  onMouseEnter() {
    if (this.TypeID == 2)
      this.setCursor('drawing');
  }

  onMouseLeave() {
    if (this.TypeID == 2)
      this.setCursor('default');
  }

  setCursor(mode: 'default' | 'drawing' | 'panning') {
    const canvas = this.imageRef.nativeElement;
    //console.log("switch (mode)", mode);
    switch (mode) {
      case 'drawing':
        canvas.style.cursor = 'crosshair';
        break;
      case 'panning':
        canvas.style.cursor = 'grab';
        break;
      default:
        canvas.style.cursor = 'default';
    }
  }

  canAdjustCrack(cp: any): boolean {
    if (!this.implementInspectionId || !this.inspectionDate || !cp.InstallDate || this.OPId > 0) {
      return false;
    }

    return new Date(cp.InstallDate) <= new Date(this.inspectionDate);
  }

  adjustCrackStatus(cp: any): void {
    if (!this.canAdjustCrack(cp)) {
      return;
    }

    // Open your status dialog here
    console.log('Adjust crack status', cp);
    this._inspection.GetAllObservationPointsByCompType(this.schematicID, 0, this.implementInspectionId, cp.ObservationPointId).subscribe(r => {
      const observations = r;
      //this.componentTypes = this.getDistinctComponentTypes(this.observations);
      //console.log("observations:, this.componentTypes", this.observations, this.componentTypes);

      if (observations?.length > 0) {
        observations.forEach(obs => {



          obs.ObservationMeasurements = obs.ObservationMeasurementsJson
            ? JSON.parse(obs.ObservationMeasurementsJson)
            : []
          //console.log("obs.ObservationMeasurements", obs.ObservationMeasurements);

          obs.ObsList = obs.ObsListJson
            ? JSON.parse(obs.ObsListJson)
            : []

          obs.obsSeverityList = obs.ObsSeverityJson
            ? JSON.parse(obs.ObsSeverityJson)
            : []


          obs.ObservationImages =
            obs.ObservationImagesJson
              ? JSON.parse(obs.ObservationImagesJson)
              : [];

          obs.severityIDs =
            obs.SeverityIDsJson
              ? JSON.parse(obs.SeverityIDsJson)
              : [];

          if (obs?.ObsList?.length > 0 && obs?.ObservationTypeName === 'Crack') {
            obs.obsId = obs.severityIDs?.[0] ?? null;
          }


        });
      }
      console.log('popup edit observations', observations);
      this.checkExistingObsPoint(observations?.[0]);
      this._allowDelete = false;
      this.isStartEdit = false;
      this.isEndEdit = false;
    });


  }

  getCrackTooltip(cp: any): string {
    return [
      this.canAdjustCrack(cp) ? 'Click to change crack status.' : null,
      cp.ObservationPointName,
      `Crack Date - ${cp.InstallDate}`,
      `Current Length - ${cp.CurrentLength} ${this.userUOM}`,
      `Crack Status - ${cp.CrackStatus}` +
      (cp.CrackSeverity != null ? ` - Severity ${cp.CrackSeverity}` : '') +
      (cp.CrackStatusId !== 1 ? ` - (${cp.WornPct}% Worn)` : '')
    ]
      .filter(Boolean)
      .join('\n');
  }

//onOpened(opened: boolean): void {
//  if (!opened) {
//    return;
//  }
//  setTimeout(() => {
//    const pane = document.querySelectorAll('.cdk-overlay-pane');
//    const overlay = pane[pane.length - 1] as HTMLElement;
//    if (!overlay) {
//      return;
//    }
//    const rect = overlay.getBoundingClientRect();
//    if (rect.bottom > window.innerHeight) {
//      const overflow = rect.bottom - window.innerHeight + 20;
//      const current = getComputedStyle(overlay).transform;
//      overlay.style.transform =
//        current === 'none'
//          ? `translateY(-${overflow}px)`
//          : `${current} translateY(-${overflow}px)`;
//    }
//  });
//}

  onOpened(opened: boolean): void {
    console.log(document.querySelectorAll('.cdk-overlay-pane'));
    if (!opened) {
      return;
    }

    setTimeout(() => {
      const panel = document.querySelector('.mat-select-panel') as HTMLElement;
      if (!panel) {
        return;
      }

      const rect = panel.getBoundingClientRect();
      const availableHeight = window.innerHeight - rect.top - 10;

      panel.style.maxHeight = `${availableHeight}px`;
      panel.style.overflowY = 'auto';
    });
  }



}

export function deepClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}
